export default {"src":"https://web.cdn.greenlight.com/2.1355.2/_next/static/media/arrow-down.1cab016f.svg","height":7,"width":13,"blurWidth":0,"blurHeight":0};